var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppLayout',{attrs:{"fluid":"","enable-footer":false,"enable-background":false}},[_c('Register')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }